import { IItem, instanceOfIItem } from "./IItem";
import { NumericFormatKinds } from "../NumericFormatKinds";

export interface IMoneyFormatable extends IItem {
  isFreeInputable: boolean;
  isNumeric: boolean;
  numericFormat: NumericFormatKinds;
  value: any;
}

export function instanceOfIMoneyFormatable(instance: any): instance is IMoneyFormatable {
  return instance
    && (instance.isFreeInputable !== undefined)
    && (instance.isNumeric !== undefined)
    && (instance.numericFormat !== undefined)
    && instanceOfIItem(instance);
}
